/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getStepTemplateTable = params => {
  return axios.post(`${base}/query_substep`, params)
}
export const getStepTemplateDetail = params => {
  return axios.get(`${base}/substep_${params.id}`, params)
}
export const exportStepTemplateData = params => {
  return axios.get(`${base}/exportStepTemplateData/${params.id}`, {params})
}
export const createStepTemplateData = params => {
  return axios.post(`${base}/create_substep`, params)
}
export const updateStepTemplateData = params => {
  return axios.post(`${base}/modify_substep_${params.id}`, params)
}
export const uploadStepTemplateFile = (params, config) => {
  return axios.post(`${base}/substep/uploadfile`, params, config)
}
export const deleteStepTemplateData = params => {
  return axios.post(`${base}/delete_substep_${params.id}`, params)
}
export const copyStepTemplateData = params => {
  return axios.post(`${base}/copy_substep_${params.id}`, params)
}
export const batchUpdateTaskByStepTemplate = params => {
  return axios.post(`${base}/update_based_on_substep_${params.id}`, params)
}
export const getStepTemplateLog = params => {
  return axios.get(`${base}/substep/log_${params.id}`, params)
}
export const addQuestionToStepTemplate = params => {
  return axios.post(`${base}/add_question_substep_${params.substep_id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/step-template/step-template.api.js